import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

const TeamPicker = ({ value, onChange, teamGroups, options }) => {
    const displaySet = useMemo(
        () => new Set(options.map(([display]) => display)),
        [options],
    );

    const handleToggle = useCallback((teamValue) => {
        const next = value.includes(teamValue)
            ? value.filter(t => t !== teamValue)
            : [...value, teamValue];
        onChange(next);
    }, [value, onChange]);

    const handleGroupToggle = useCallback((group) => {
        const owned = group.teams.filter(t => displaySet.has(t));
        const rawForDisplay = new Map(options.map(([display, raw]) => [display, raw]));
        const ownedRaw = owned.map(t => rawForDisplay.get(t)).filter(Boolean);

        const allSelected = ownedRaw.every(r => value.includes(r));
        if (allSelected) {
            onChange(value.filter(r => !ownedRaw.includes(r)));
        } else {
            onChange([...new Set([...value, ...ownedRaw])]);
        }
    }, [displaySet, options, value, onChange]);

    return (
        <div className="tb-team-picker">
            {teamGroups.length > 0 && (
                <div className="tb-team-picker__groups">
                    {teamGroups.map(group => (
                        <button
                            key={group.label}
                            type="button"
                            className="tb-team-picker__group-btn"
                            onClick={() => handleGroupToggle(group)}
                        >
                            {group.label}
                        </button>
                    ))}
                </div>
            )}
            <div className="tb-team-picker__options">
                {options.map(([display, raw]) => (
                    <button
                        key={raw}
                        type="button"
                        className={`tb-team-picker__btn${value.includes(raw) ? ' tb-team-picker__btn--active' : ''}`}
                        onClick={() => handleToggle(raw)}
                    >
                        {display}
                    </button>
                ))}
            </div>
        </div>
    );
};

TeamPicker.propTypes = {
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    teamGroups: PropTypes.array,
    options: PropTypes.array.isRequired,
};

TeamPicker.defaultProps = {
    teamGroups: [],
};

export default TeamPicker;
